import React from "react";

import { Box, Stack, SvgIconProps, Typography } from "@mui/material";

import SideNavButtonIcon from "@app/analytics/components/SideNav/SideNavButtonIcon";
import Link, { LinkProps } from "@app/common/components/Link";

interface SideNavLinkProps extends LinkProps {
  Icon: React.FunctionComponent<SvgIconProps>;
}

const SideNavLink = ({ Icon, children, sx, ...props }: SideNavLinkProps) => {
  return (
    <Link
      {...props}
      sx={{ ...sx, width: "100%", color: "shades.neutral.800", padding: 1 }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="flex-start"
        spacing={1}
      >
        <Box sx={{ color: "shades.neutral.400" }}>
          <SideNavButtonIcon Icon={Icon} />
        </Box>
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <Typography
            variant="bodySecondaryMed"
            sx={{
              whiteSpace: "nowrap",
            }}
          >
            {children}
          </Typography>
        </Stack>
      </Stack>
    </Link>
  );
};

export default SideNavLink;
